/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Withdrawal_TitleInputs */

const en_legal_withdrawal_title = /** @type {(inputs: Legal_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right of Withdrawal`)
};

const pl_legal_withdrawal_title = /** @type {(inputs: Legal_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo odstąpienia od umowy`)
};

/**
* | output |
* | --- |
* | "Right of Withdrawal" |
*
* @param {Legal_Withdrawal_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_withdrawal_title = /** @type {((inputs?: Legal_Withdrawal_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Withdrawal_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_withdrawal_title(inputs)
	return en_legal_withdrawal_title(inputs)
});